import { render, staticRenderFns } from "./ItemsViewItemType.vue?vue&type=template&id=5c40e348&scoped=true&"
import script from "./ItemsViewItemType.vue?vue&type=script&lang=js&"
export * from "./ItemsViewItemType.vue?vue&type=script&lang=js&"
import style0 from "./ItemsViewItemType.vue?vue&type=style&index=0&id=5c40e348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c40e348",
  null
  
)

export default component.exports